import loadingIcon from '@/assets/images/loading_icon.png'

/* The one shared visual: ClipRRect(radius 8) -> Image(loading_icon.png,
 * 200x200, cover) with ScaleEffect 1.0->1.2, 600ms, linear, loop+reverse.
 * Used by AppLoading and SendReassuranceAnimation (and the dead
 * tracking_copy). */

export function PulsingLogo() {
  return (
    <img
      src={loadingIcon}
      alt=""
      width={200}
      height={200}
      style={{
        width: 'var(--loading-img)',
        height: 'var(--loading-img)',
        objectFit: 'cover',
        borderRadius: 8,
        animation: 'ffPulse 600ms linear infinite alternate',
      }}
    />
  )
}
